// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__f4srX","title":"Header_title__xL9y_","left":"Header_left__2LzSo","clinicName":"Header_clinicName__1dopr"};